/**
 * Domain pattern regex for validating website URLs.
 *
 * This pattern validates domain names without protocol (e.g., "example.com").
 * It requires:
 * - Alphanumeric characters, dots, and hyphens
 * - At least one dot (TLD requirement)
 * - Proper domain segment format (each segment: 1-63 chars, alphanumeric with hyphens allowed in middle)
 *
 * Note: This is used for validating domain names that will be normalized to full URLs by the backend.
 * Full URLs (with http:// or https://) should be validated using the URL constructor instead.
 */
export const DOMAIN_PATTERN = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
